import { apiClient as api } from "./httpClient";

/**
 * Acompanhamento de processos do paciente. Mostra a EXISTÊNCIA do registro, nunca o conteúdo
 * clínico (RN-540): a coordenação vê que falta evolução, não o que ela diz.
 */
export interface PatientTrackingItem {
  patientId: string;
  patientName: string;
  /** tracked = em acompanhamento; inactive = sem atendimento; never = nunca atendido */
  situation: string;
  registerComplete: boolean;
  hasPhoto: boolean;
  hasActiveLink: boolean;
  hasDiagnosis: boolean;
  hasPlanGoals: boolean;
  hasAnamnesis: boolean;
  lastEvaluationDate: string | null;
  lastAttendance: string | null;
  lastPresence: string | null;
  presencesLastMonth: number;
  nextSchedule: string | null;
  lastEvolution: string | null;
  nextEvaluationDue: string | null;
}

export interface PatientTrackingSummary {
  patients: number;
  registerComplete: number;
  withPhoto: number;
  withActiveLink: number;
  withDiagnosis: number;
  withPlanGoals: number;
  withEvaluation: number;
  withAnamnesis: number;
  evolutionUpToDate: number;
  evaluationOverdue: number;
  nextSchedule: number;
  withPresenceLastMonth: number;
}

export interface PatientTrackingPage {
  items: PatientTrackingItem[];
  summary: PatientTrackingSummary;
  total: number;
}

export interface PatientTrackingFilters {
  situation?: string;
  search?: string;
  professionalId?: string;
  /** recorte por item faltante: é assim que a coordenação distribui tarefa */
  pending?: string;
  activityDays?: number;
  evaluationCycleMonths?: number;
  evolutionGraceDays?: number;
}

export const patientTrackingService = {
  /** Planilha do recorte, sem paginação: cada marca vira uma coluna Sim/Não. */
  exportXlsx: async (filters: PatientTrackingFilters): Promise<Blob> => {
    const response = await api.get("/reports/patient-tracking/export", {
      params: {
        ...(filters.situation ? { situation: filters.situation } : {}),
        ...(filters.search ? { search: filters.search } : {}),
        ...(filters.professionalId ? { professionalId: filters.professionalId } : {}),
        ...(filters.pending ? { pending: filters.pending } : {}),
        ...(filters.evaluationCycleMonths ? { evaluationCycleMonths: filters.evaluationCycleMonths } : {}),
      },
      responseType: "blob",
    });
    return response.data;
  },

  get: async (
    filters: PatientTrackingFilters,
    page: number,
    pageSize: number,
  ): Promise<PatientTrackingPage> => {
    const response = await api.get("/reports/patient-tracking", {
      params: {
        page,
        pageSize,
        ...(filters.situation ? { situation: filters.situation } : {}),
        ...(filters.search ? { search: filters.search } : {}),
        ...(filters.professionalId ? { professionalId: filters.professionalId } : {}),
        ...(filters.pending ? { pending: filters.pending } : {}),
        ...(filters.activityDays ? { activityDays: filters.activityDays } : {}),
        ...(filters.evaluationCycleMonths ? { evaluationCycleMonths: filters.evaluationCycleMonths } : {}),
        ...(filters.evolutionGraceDays ? { evolutionGraceDays: filters.evolutionGraceDays } : {}),
      },
    });
    return response.data;
  },
};
